import React from 'react';
import classes from './CategoryItem.css';
import { NavLink } from 'react-router-dom';

const categoryItem = props => {
    const bridesClasses = [classes.CategoryName];

    if (props.gold) {
        bridesClasses.push(classes.Gold);
    }

    return (
        <li className={classes.CategoryItem}>
            <NavLink className={classes.CategoryItemLink} to={props.link}>
                <div className={classes.CategoryLogo}>
                    <img src={props.logo} alt="" />
                </div>
                <div className={classes.CategoryImage}>
                    <img src={props.image} alt={props.name} />
                    <div className={bridesClasses.join(' ')}>{props.name}</div>
                </div>
            </NavLink>
        </li>
    );
};

export default categoryItem;



// WEBPACK FOOTER //
// ./src/components/CategoryItem/CategoryItem.js